<template>
    <div>
        <h5>Evaluaciones enviadas</h5>
        <EvaluationAttemptsList class="mt-2"/>
    </div>
</template>

<script>
import EvaluationAttemptsList from './TrainingSetting/Evaluation-attempts-list.vue'

export default {
    name: 'UserSetting',

    components: {
        EvaluationAttemptsList
    },
}
</script>
